import React from "react";
import { Input } from "@revvsales/components";
import { RevvForm /* ErrorMessages */ } from "../../../../commonComponents";

import {
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "../../DynamicField/DynamicFieldComponents/CustomFieldRulesMap";

export default class PhoneFieldFormMode extends React.Component {
  state = {
    phonefieldValues: {
      default: JSON.parse(JSON.stringify(this.props.initialProps.value)),
    },
  };

  _handleOnBlur = (event, value, handleBlur, isValidated) => {
    handleBlur(event);
    // If the field is validated & there is a value then only
    // make an API call and update the redux store
    if ((isValidated && value) || value === "") {
      const { id } = this.props.initialProps;
      this.props._updateDynamicFieldsInDoc(id, value);
      this._checkForUpdateField(value);
    }
  };

  _checkForUpdateField = currentValue => {
    const { id, value: initialValue } = this.props.initialProps;
    if (initialValue !== currentValue) {
      this.props._updateField(id, currentValue);
      if (currentValue) {
        this.props.filledStatus(true);
      } else this.props.filledStatus(false);
    }
  };

  render() {
    const {
      id,
      label,
      placeholder /* docIsLocked */,
    } = this.props.initialProps;
    return (
      <React.Fragment>
        <RevvForm
          revvFormId={id}
          initialFormValue={this.state.phonefieldValues}
          customFieldName="PHONE"
          customFieldComponentRules={CustomFieldComponentRules}
          validateOnChange
          customFieldComponentMessages={CustomFieldComponentMessages}
          render={formProps => {
            const { handleChange, handleBlur, messages, values } = formProps;
            return (
              <React.Fragment>
                <Input
                  id={id}
                  name="default"
                  type="number"
                  className="form-mode-input"
                  // {`form-mode-input ${
                  //   messages.default &&
                  //   (messages.default.required ||
                  //     messages.default.validatePhone) !== ""
                  //     ? "danger-border"
                  //     : ""
                  // }`}
                  placeholder={`${placeholder || `Enter ${label}`}`}
                  onKeyDown={e => e.keyCode === 69 && e.preventDefault()}
                  onChange={event => handleChange(event)}
                  onBlur={event =>
                    this._handleOnBlur(
                      event,
                      values.default,
                      handleBlur,
                      !messages.default,
                    )
                  }
                  value={values && values.default ? values.default : ""}
                  disabled={this.props.isLocked}
                  autoFocus
                  data-test="phone-number-field-form-mode"
                />
                {/** 
                <div>
                  {messages.default && (
                    <ErrorMessages messages={messages.default.validatePhone} />
                  )}
                </div>
                */}

                {/* <JSONPretty id="json-pretty" data={allInAll} /> */}
              </React.Fragment>
            );
          }}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentV2/FormView/FormModeComponents/PhoneFieldFormMode.js